"use client";

import React from "react";

const SealantApplicationProcess: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Sealant Application Process: A Step by Step Guide
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Now that you understand the benefits of dental sealants let&#39;s walk through
        the application process so you know what to expect during your appointment.
        The procedure is quick, painless, and typically takes just a few minutes
        per tooth.
      </p>
      <ol className="list-decimal list-inside space-y-3 text-gray-700 text-base sm:text-lg">
        {[
          <span key="1">
            <strong>Preparation:</strong> Your dentist will first clean and dry the
            tooth surface that needs sealing. They may also apply a solution called
            etchant to help the sealant bond better with your enamel.
          </span>,
          <span key="2">
            <strong>Application:</strong> After preparing the tooth, your dentist
            will paint a thin layer of liquid sealant onto the chewing surfaces of
            your back teeth. This material is usually clear or white in color and
            has a consistency similar to nail polish.
          </span>,
          <span key="3">
            <strong>Curing:</strong> Once the sealant is applied, your dentist will
            use a special blue light to harden (or cure) the material. This process
            typically takes around 20-30 seconds per tooth. During this time, you
            may feel some warmth or slight pressure, but it should not be
            uncomfortable.
          </span>,
          <span key="4">
            <strong>Polishing:</strong> After the sealant has cured, your dentist
            will polish the treated teeth to ensure a smooth surface that&#39;s easy to
            clean and free of any rough edges.
          </span>,
        ].map((item, idx) => (
          <li
            key={idx}
            className="group hover:bg-gray-50 transition-all duration-300 rounded-md py-1"
          >
            {item}
          </li>
        ))}
      </ol>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        That&#39;s it! The entire process is quick and straightforward, with minimal
        discomfort or downtime. In fact, you should be able to eat and drink
        normally immediately after your appointment.
      </p>
    </div>
  );
};

export default SealantApplicationProcess;